import { render, staticRenderFns } from "./SubAccountList.component.vue?vue&type=template&id=ba27bec8&"
import script from "./SubAccountList.component.vue?vue&type=script&lang=ts&"
export * from "./SubAccountList.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports